module.exports = __webpack_public_path__ + "static/vslide_1@2x-b49ca948f61792e4178f390b84f25838.png";